import FormWrapper from '@/components/form/Wrapper';
import { useAppAlert } from '@Components/AppAlert';

import SettingsForm from '../components/SettingsForm';
import fields from '../components/system_config';
import { SettingProvider, useSettingStore } from '../store';

function SystemSettingsForm() {
  const { settings, useLoad, useSubmit } = useSettingStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad()

  const handleSubmit = useSubmit()

  const handleSubmitSettings = async payload => {
    try {
      await handleSubmit(payload)
      handleSuccess('Success', 'Setting saved.');
    } catch (error) {
      handleError('Error', 'Setting was not saved.');
    }
  }

  return <>
    <FormWrapper title="System Settings">
      <SettingsForm
        settingKey={'system_config'}
        title={"System Settings"}
        settings={settings}
        options={fields}
        onSubmit={handleSubmitSettings}
        isSystem
      />
    </FormWrapper>
  </>
}

export default function SystemSettingFormLayout() {
  return <SettingProvider>
    <SystemSettingsForm />
  </SettingProvider>;
}
